<template>
  <div class="container page">
    <van-nav-bar :title="$t('mine.setbank.title')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="wrapper">
      <!-- 银行卡区：后台 bank_bind_switch 关闭时整块隐藏 -->
      <div class="block" v-if="bankSwitch">
        <div class="block-title">{{ $t('payMethod.bankCard') }}</div>
        <div class="card" v-if="bankCard">
          <div class="card-info">
            <div class="row-content">{{ bankCard.bankinfo }}</div>
            <div class="row-content">{{ userInfo.name }}</div>
            <div class="row-content">{{ bankCard.bankid }}</div>
          </div>
          <span class="unbind-btn" @click="toUnbind(bankCard)">{{ $t('payMethod.unbind') }}</span>
        </div>
        <div class="add-card" v-else @click="toBindCard()">
          <van-icon name="plus" />
          <span>{{ $t('mine.setbank.addCard') }}</span>
        </div>
      </div>
      <!-- 钱包区：遍历 type=2 -->
      <div class="block">
        <div class="block-title">{{ $t('payMethod.wallet') }}</div>
        <div class="card" v-for="item in wallets" :key="item.id">
          <div class="card-info">
            <div class="row-content">{{ item.coin.toUpperCase() }}</div>
            <div class="row-content addr">{{ item.bankid }}</div>
          </div>
          <span class="unbind-btn" @click="toUnbind(item)">{{ $t('payMethod.unbind') }}</span>
        </div>
        <div class="add-card" @click="toBindWallet()">
          <van-icon name="plus" />
          <span>{{ $t('payMethod.bindNew') }}</span>
        </div>
      </div>
      <div class="tips">{{ $t('mine.setbank.tips') }}</div>
    </div>
    <!-- 绑定新钱包弹层：币种 + 地址 + 提现密码 -->
    <van-popup v-model="showBind" round position="bottom" :style="{ height: '60%' }">
      <div class="bind-form">
        <div class="bind-label">{{ $t('payMethod.bindNew') }}</div>
        <div class="bind-sub">{{ $t('recharge.chooseCoin') }}</div>
        <van-radio-group v-model="bindCoin" direction="horizontal" class="coin-group">
          <van-radio v-for="c in coins" :key="c" :name="c">{{ c.toUpperCase() }}</van-radio>
        </van-radio-group>
        <van-field v-model="bindAddr" :label="$t('payMethod.wallet')" :placeholder="$t('recharge.address')" />
        <van-field v-model="bindPassword" type="password" :label="$t('payMethod.payPassword')" :placeholder="$t('payMethod.payPassword')" />
        <van-button class="submit-btn" type="default" @click="doBindWallet()">{{ $t('common.confirm') }}</van-button>
      </div>
    </van-popup>
    <!-- 解绑验密弹窗 -->
    <van-dialog v-model="showUnbind" :title="$t('payMethod.confirmUnbind')" show-cancel-button :before-close="unbindBeforeClose">
      <van-field v-model="unbindPassword" type="password" :placeholder="$t('payMethod.payPassword')" class="dialog-field" />
    </van-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bankSwitch: true,
      bankCard: null,
      wallets: [],
      coins: [],
      userInfo: {},
      showBind: false,
      bindCoin: '',
      bindAddr: '',
      bindPassword: '',
      showUnbind: false,
      unbindId: 0,
      unbindPassword: ''
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
        if(res.code === 200){
          const list = Array.isArray(res.data.list) ? res.data.list : [];
          this.bankCard = list.find(v => Number(v.type) === 1) || null;
          this.wallets = list.filter(v => Number(v.type) === 2);
          this.bankSwitch = res.data.bank_switch !== false;
          this.coins = Array.isArray(res.data.coins) ? res.data.coins : [];
        }else if(res.code === 401){
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.name = res.data.name;
        }else if(res.code === 401){
          this.$toast(res.msg);
        }
      })
    },
    toBindCard() {
      if (!this.userInfo.name) {
        this.$router.push("Setname");
        this.$toast(this.$t('mine.setbank.setNameFirst'));
        return true;
      }else if(!this.userInfo.paypassword){
        this.$router.push("SetPayPassword");
        this.$toast(this.$t('mine.setbank.setPayPasswordFirst'));
        return true;
      } else {
        this.$router.push({path:'/BindCard'})
      }
    },
    toBindWallet(){
      if(!this.userInfo.paypassword){
        this.$router.push("SetPayPassword");
        this.$toast(this.$t('mine.setbank.setPayPasswordFirst'));
        return true;
      }
      if(!this.coins.length){
        this.$toast(this.$t('common.emptyData'));
        return true;
      }
      this.bindCoin = this.coins[0];
      this.bindAddr = '';
      this.bindPassword = '';
      this.showBind = true;
    },
    doBindWallet(){
      if(!this.bindCoin){
        this.$toast(this.$t('recharge.chooseCoin'));
        return false;
      }
      if(!this.bindAddr || this.bindAddr.length < 20){
        this.$toast(this.$t('payMethod.bindNew'));
        return false;
      }
      if(!this.bindPassword){
        this.$toast(this.$t('common.passwordRequired'));
        return false;
      }
      this.$http({
        method: 'post',
        data:{type:2, coin:this.bindCoin, bankid:this.bindAddr, paypassword:this.bindPassword},
        url: 'user_set_bank'
      }).then(res=>{
        if(res.code === 200){
          this.$toast(res.msg);
          this.showBind = false;
          this.getUserBankInfo();
        }else if(res.code === 401){
          this.$toast(res.msg);
        }
      })
    },
    toUnbind(item){
      this.unbindId = item.id;
      this.unbindPassword = '';
      this.showUnbind = true;
    },
    // 验密失败保持弹窗不关，可直接重输
    unbindBeforeClose(action, done){
      if(action !== 'confirm'){
        done();
        return;
      }
      if(!this.unbindPassword){
        this.$toast(this.$t('common.passwordRequired'));
        done(false);
        return;
      }
      this.$http({
        method: 'post',
        data:{id:this.unbindId, paypassword:this.unbindPassword},
        url: 'user_unbind_bank'
      }).then(res=>{
        if(res.code === 200){
          this.$toast(res.msg);
          this.getUserBankInfo();
          done();
        }else {
          this.$toast(res.msg);
          done(false);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.van-cell {
  font-size: 35px;
  line-height: 80px;
}

.container p{
  padding: 0 15px;
  margin-top: 15px;
  font-size: 30px;
  color: #dc2037;
}
.wrapper{
  height: calc(100% - 50px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 40px;
}
.block-title{
  padding: 25px 20px 10px;
  font-size: 30px;
  color: #979799;
}
.wrapper .add-card{
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000;
  background-color: #fff;
  height: 150px;
}
.wrapper .add-card span{
  margin-left: 10px;
  font-size: 30px;
}
.wrapper .card{
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #fff;
  padding: 20px 0;
}
.wrapper .card .card-info {
  margin-left: 20px;
  flex: 1;
  color: #000;
  min-width: 0;
}
.wrapper .card .card-info .row-content{
  margin: 15px 0;
  line-height: 20px;
  font-size: 30px;
}
.wrapper .card .card-info .row-content.addr{
  font-size: 24px;
  word-break: break-all;
}
.wrapper .card .unbind-btn{
  margin: 0 25px;
  padding: 8px 24px;
  font-size: 24px;
  color: #fff;
  border-radius: 30px;
  background: #dc2037;
  white-space: nowrap;
}
.wrapper .tips {
  margin: 15px 15px;
  font-size: 25px;
  color: #979799;
}
.bind-form{
  padding: 30px;
}
.bind-form .bind-label{
  font-size: 35px;
  font-weight: bolder;
  color: #000;
  text-align: center;
}
.bind-form .bind-sub{
  padding: 20px 0 10px;
  font-size: 26px;
  color: #979799;
}
.bind-form .coin-group{
  padding: 10px 0 20px;
}
.bind-form .submit-btn{
  margin: 30px 0 10px;
  height: 80px;
  line-height: 1.22667rem;
  border-radius: 50px;
  color: #fff;
  font-size: 30px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(
      90deg,#e6c3a1,#7e5678);
}
.dialog-field{
  padding: 20px 0;
}
</style>
